import { useEffect, useState } from 'react';
import { Column } from '../pages/Components/Table/Types';
import { useForm } from './useForm';
import { ImportacaoXMLCadastrar } from '../routes/RoutesNames';
import { useNavigate } from 'react-router-dom';
import ImportacaoXMLController from '../controllers/ImportacaoXMLController';
import { ListaNotaFiscalEntrada } from '../shared/types/importacaoXML';
import { DatetimeBR } from '../shared/utils/helpers/date';
import { formatCurrency } from '../shared/utils/helpers/numbers';
import { toast } from 'react-toastify';
import * as React from 'react';
import { ButtonMenu } from '../shared/components/ButtonMenu';

interface Row {
  BtnExcluir?: JSX.Element;
  DataEmissao?: string;
  TipoArquivo?: string;
  Fornecedor?: string;
  Serie?: number;
  Id: number;
  ValorTotal?: string;
  BtnBaixar?: JSX.Element;
}

const useXmlImportPesquisar = () => {

  const navigate = useNavigate();
  const columns: Column[] = [
    { id: 'TipoArquivo', label: 'Arquivo', align: 'center', width: 50 },
    { id: 'DataEmissao', label: 'Data Emissao', minWidth: 0 },
    { id: 'Fornecedor', label: 'Fornecedor', minWidth: 0 },
    { id: 'Serie', label: 'Serie', minWidth: 0 },
    { id: 'Id', label: 'Numero', minWidth: 0 },
    { id: 'Status', label: 'Status', minWidth: 0 },
    { id: 'ValorTotal', label: 'Valor Total', minWidth: 0 },
    { id: 'BtnMenu', label: 'Ações', width: 60, minWidth: 0 },
  ];
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(false);
  const handleNavigation = () => {
    navigate(ImportacaoXMLCadastrar);
  };
  const [modalPreviewOpen, setModalPreviewOpen] = useState(false);
  const [nfPreView, setNfPreView] = useState<any>({});
  const [activeTab, setActiveTab] = useState('1');

  const onSubmit = async (data: any) => {
    await getList(data);
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: {},
  });

  const handleOpenModalView = async (nfId: number) => {
    setLoading(true);
    const result = await ImportacaoXMLController.consultarNfEntradaUnico(nfId);
    setLoading(false);
    console.log("RESULT AQUI -->", result)
    setNfPreView(result);
    setModalPreviewOpen(true);
  };

  const handleCloseModalView = () => {
    setModalPreviewOpen(false);
  }

  /**
   * Exclui a importação e recarrega a lista.
   *
   * Até aqui este `onClick` era `console.log(item.prod_id)` — um esqueleto que nunca foi
   * ligado, de um campo que nem existe na linha (a chave é `nfe_id`). Pior que botão
   * ausente: a confirmação dizia que a ação era irreversível, o operador confirmava e nada
   * acontecia.
   *
   * O erro da procedure sobe inteiro para o toast porque ELE É A RESPOSTA: nota finalizada
   * e nota com devolução registrada são recusadas com o motivo, e no segundo caso com a
   * lista de quais devoluções travam.
   */
  const handleExcluir = async (item: any) => {
    setLoading(true);
    const resultado = await ImportacaoXMLController.excluirNfEntrada(item.nfe_id);
    setLoading(false);

    if (!resultado.ok) {
      toast(resultado.erro, { type: 'error' });
      return;
    }

    /* A mensagem diz o que ficou verdadeiro, e não "excluído com sucesso": se o número
       voltou a ficar livre é a informação que o operador vai usar em seguida. */
    const liberado = resultado.dados?.numero_liberado === 'sim';
    toast(
      `Importação da nota ${resultado.dados?.numero ?? ''} excluída.` +
        (liberado ? ' O número está livre para reimportar.' : ''),
      { type: 'success' }
    );

    /* Recarrega com os MESMOS filtros que estavam na tela. Chamar getList() sem argumento
       limparia a busca do operador junto com a linha excluída. */
    await getList(form.values as ListaNotaFiscalEntrada);
  };

  const getList = async (data?: ListaNotaFiscalEntrada) => {
    setLoading(true);
    const result = await ImportacaoXMLController.consultarNfEntrada({
      TipoArquivo: data?.TipoArquivo ?? '',
      CliNome: data?.CliNome ?? '',
      NfeSerie: data?.NfeSerie ?? 0,
      NfeStatus: data?.NfeStatus ?? '',
      NfeValorTotalNf: data?.NfeValorTotalNf ?? '',
      NfeDataEmissao: data?.NfeDataEmissao ?? '',
    });
    setRows(
      result.map((item: any) => {
        return {
          DataEmissao: DatetimeBR.getFullFriendlyDate(
            item.nfe_dataEmissao,
            false
          ),
          TipoArquivo: item.nfe_tipo_arquivo,
          Fornecedor: item.cli_nome,
          Serie: item.nfe_ser,
          Id: item.nfe_id,
          Status: item.nfe_status,
          ValorTotal: formatCurrency(item.nfe_valorTotalNf, 2, 2),
          BtnMenu: (
            <ButtonMenu
              items={[
                {
                  onClick: () => {handleOpenModalView(item.nfe_id)},
                  menu: 'Visualizar',
                },
                {
                  onClick: () => { handleExcluir(item); },
                  menu: 'Excluir',
                  confirmar:
                    `Excluir a importação da nota ${item.nfe_numeroNf ?? ''} de ` +
                    `${item.cli_nome ?? 'fornecedor não identificado'}? ` +
                    `A nota sai da lista e o número volta a ficar livre para reimportar.`,
                }
              ]}
            />
          )
        };
      })
    );
    setLoading(false);
  };

  const handleFinishNf = async () => {
    setLoading(true)
    const result = await ImportacaoXMLController.finalizarNfEntrada(nfPreView.nfe_id);
    setLoading(false);

    console.log('result', result);
    if (result) {
      setModalPreviewOpen(false);
      toast('Nota Fiscal finalizada com sucesso!', { type: 'success' });
    }
    if (!result) {
      toast('Houve um erro ao finalizar nota fiscal', { type: 'error' });
    }
  }

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    getList();
  }, []);

  return {
    ...form,
    loading,
    columns,
    rows,
    handleNavigation,
    modalPreviewOpen,
    handleCloseModalView,
    nfPreView,
    handleFinishNf,
    activeTab,
    handleTabChange,
  };
};

export default useXmlImportPesquisar;
